import "./App.css";
import Link from "./pages/link";
import { Route, Routes, useLocation } from "react-router-dom";
import Home from "./pages/Home";
import TermsOfService from "./components/terms-of-service";
import PrivacyPolicy from "./components/privacy-policy";
import DataDeletionPage from "./components/data-delete";
import Event from "./pages/Event";
import DownloadApp from "./pages/DownloadApp";
import Post from "./pages/Post";
import UserProfile from "./pages/UserProfile";
import ScrollToTop from "./components/ScrollToTop";
import RouteMetadata from "./components/RouteMetadata";

function App() {
  const { pathname } = useLocation();
  return (
    <div className="App min-h-full overflow-x-hidden z-0">
      <ScrollToTop />
      <RouteMetadata />
      <Routes key={pathname}>
        <Route path="/" element={<Home />} />
        <Route path="/e/:slug" element={<Event />} />
        <Route path="/p/:postPublicId" element={<Post />} />
        <Route path="/:username" element={<UserProfile />} />
        <Route path="/events/:id" element={<Event />} />
        <Route path="/posts/:id" element={<Post />} />
        <Route path="/users/:id" element={<UserProfile />} />
        <Route path="link/:type" element={<Link />} />
        <Route path="link/:type/:id" element={<Link />} />
        <Route path="terms-of-service" element={<TermsOfService />} />
        <Route path="privacy-policy" element={<PrivacyPolicy />} />
        <Route path="data-deletion" element={<DataDeletionPage />} />
        <Route path="download-app" element={<DownloadApp />} />
      </Routes>
    </div>
  );
}

export default App;
